{
  "id": 18,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 21,
  "kinds": 6,
  "goals": [
    { "type": "stain" }
  ],
  "stars": [3320, 4710],
  "board": [
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.825, "movesLeft": 7.5, "closeLosses": 0.171, "target": 0.78 }
}
